import { createAction } from "redux-actions";
import { FETCH_USER, CREATE_USER, UPDATE_USER, FIND_USER } from "../constants";
import { feathersCreateData } from "./../services";
import { serverUpdateUser } from "./../services/users";
import { serverFindData } from "../services/crud";
import { urlUsers } from "./../services/urls";



// export const getUserData = createAction(FETCH_USER, (id, field) => serverFind(id, urlBalances, field)())
//conexion con web service cooperativa
export const getUserData = createAction(FETCH_USER, (cedule) => feathersCreateData('core-server',
{ service: 'CLIENT', func: 'GET_USER', cedule })())
export const findUser = createAction(FIND_USER, (query) => serverFindData('process-user-question', query)())
export const createUser = createAction(CREATE_USER, (data) => feathersCreateData('users', data)())
export const updateUser = createAction(UPDATE_USER, (id, data) => serverUpdateUser(urlUsers, id, data)())
//export const updateUserFromClient = createAction(UPDATE_USER, (id, data) => serverUpdateUserFromClient(id, data)())
// export const loginSuccess = createAction(LOGIN_SUCCESS, () => ServerGetData(urlUsers)())
